import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as types from './types';

export const toggleGroupSelection = createAction(types.TOGGLE_GROUP_SELECTION);
export const toggleAllGroupsSelection = createAction(types.TOGGLE_ALL_GROUPS_SELECTION);

export const getGroupList = createApiAction(
  types.GROUP_LIST_GET,
  (payload) => api.getGroups(payload),
);

export const createGroup = createApiAction(
  types.GROUP_CREATE,
  (payload) => api.createGroup(payload),
);

export const autocompleteGetGroups = createApiAction(
  types.AUTOCOMPLETE_GROUPS_GET,
  (payload) => api.getGroups(payload),
);

export const removeGroup = createApiAction(
  types.GROUP_REMOVE,
  (payload) => api.removeGroup(payload.id)
    .then(() => payload.id) // API doesn't return ID of deleted item, so we need to return it here
    .catch((err) => {
      // eslint-disable-next-line no-param-reassign
      err.groupId = payload.id; // making life a little easier for ourselves
      throw err;
    }),
);

export const moveGroupTeams = createApiAction(
  types.GROUP_MOVE_TEAMS,
  (payload) => api.moveGroupTeams(payload),
);

export const getOrganizationGroupsUsageCSV = createApiAction(
  types.GET_ORGANIZATION_GROUPS_USAGE_CSV,
  (payload, meta, dispatch) => (
    api.getOrganizationGroupsUsageCSV(payload)
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);
